import React from 'react';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';
import { makeStyles } from '@material-ui/styles';
import { Card, Typography, Grid, colors, Link } from '@material-ui/core';
import Label from 'src/components/Label';

// import Label from 'src/components/Label';

const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  item: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.up('md')]: {
      '&:not(:last-of-type)': {
        borderRight: `1px solid ${theme.palette.divider}`
      }
    },
    [theme.breakpoints.down('sm')]: {
      // '&:not(:last-of-type)': {
      borderBottom: `1px solid ${theme.palette.divider}`
      // }
    }
  },
  itemsContainer: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  contrastLink: {
    color: theme.palette.primary.contrastText
  },
  valueContainer: {
    display: 'flex',
    color: theme.palette.primary.contrastText,
    justifyContent: 'center'
  },
  label: {
    marginLeft: theme.spacing(1)
  }
}));

function Overview({ className, ...rest }) {
  const classes = useStyles();

  const jobs = useSelector(state => state.firestore.ordered.allJobs) || [];

  const pendingJobs = jobs.filter(job => job.status === 'pending');
  const activeJobs = jobs.filter(job => job.status === 'active');
  const completedJobs = jobs.filter(job => job.status === 'complete');

  const todayJobs = jobs.filter(job => {
    return moment(job.date).isSame(moment(), 'days');
  });

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <Grid
        alignItems="center"
        className={classes.itemsContainer}
        container
        justify="space-between"
      >
        <Grid className={classes.item} item md={3} sm={6} xs={12}>
          <Typography component="h1" gutterBottom variant="overline">
            Pending Jobs
            <br />
            <small>in the last 30 days</small>
          </Typography>
          <div className={classes.valueContainer}>
            <Link component={RouterLink} to={`/orders?tab=pending`}>
              <Typography className={classes.contrastLink} variant="h3">
                {pendingJobs.length}
              </Typography>
            </Link>
          </div>
        </Grid>
        <Grid className={classes.item} item md={3} sm={6} xs={12}>
          <Typography component="h1" gutterBottom variant="overline">
            Active Jobs
            <br />
            <small>in the last 30 days</small>
          </Typography>
          <div className={classes.valueContainer}>
            <Link component={RouterLink} to={`/orders?tab=active`}>
              <Typography className={classes.contrastLink} variant="h3">
                {activeJobs.length}
              </Typography>
            </Link>
          </div>
        </Grid>
        <Grid className={classes.item} item md={3} sm={6} xs={12}>
          <Typography component="h1" gutterBottom variant="overline">
            Completed Jobs
            <br />
            <small>in the last 30 days</small>
          </Typography>
          <div className={classes.valueContainer}>
            <Link component={RouterLink} to={`/orders?tab=complete`}>
              <Typography className={classes.contrastLink} variant="h3">
                {completedJobs.length}
              </Typography>
            </Link>
          </div>
        </Grid>
        <Grid className={classes.item} item md={3} sm={6} xs={12}>
          <Typography component="h1" gutterBottom variant="overline">
            Total Jobs <br />
            <small>in the last 30 days</small>
          </Typography>
          <div className={classes.valueContainer}>
            <Link component={RouterLink} to={`/orders?tab=all`}>
              <Typography className={classes.contrastLink} variant="h3">
                {(jobs || []).length}
              </Typography>
            </Link>
            <Label
              className={classes.label}
              color={colors.orange[400]}
              variant="contained"
            >
              {`${todayJobs.length} today`}
            </Label>
          </div>
        </Grid>
      </Grid>
    </Card>
  );
}

Overview.propTypes = {
  className: PropTypes.string
};

export default Overview;
